import { render, staticRenderFns } from "./AutoPostBoostingPlacements.vue?vue&type=template&id=e5b1227c&scoped=true&"
import script from "./AutoPostBoostingPlacements.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingPlacements.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingPlacements.vue?vue&type=style&index=0&id=e5b1227c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b1227c",
  null
  
)

export default component.exports